import React from "react";
import LocationAddressForm from "./LocationAddressForm";

const LocationAddress = ({ handleChange, data, states, cities }) => {
  return (
    <div className="formgrid grid">
      <div className="field">
        <p className="heading">Location & Address </p>
        <p className="description">
          Key data for payroll, taxation, and legal compliance across regions.
        </p>
      </div>
      <LocationAddressForm
        handleChange={handleChange}
        data={data}
        states={states}
        cities={cities}
        isEdit={true}
      />
    </div>
  );
};

export default LocationAddress;
